module.exports = __webpack_public_path__ + "static/media/sc30_styleframe02_v001.9e8d9e33.webp";